import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

interface Props {
    /** QR'ın içine yazılan metin (okutulunca çözülen). */
    qrMetni: string
    /** Etiket başlığı: nokta adı ya da plaka. */
    baslik?: string | null
    /** Elle girilebilen kısa kod. */
    qrKodu?: string | null
    /** QR'ın ekrandaki boyu (px). */
    boyut?: number
    /** Çerçeve rengi (Faz 2: Lojistik mavi, Ambalaj turuncu). */
    renk?: string
    /** QR'ın altında büyük harfle iş tipi ("LOJİSTİK" / "AMBALAJ"). */
    isTipi?: string
}

/**
 * Ekranda QR önizlemesi: QR + başlık + kısa kod (11.10.2026; QR Noktaları ve Araç Tanımları).
 * Yazdırma için `qrYazdir` kullanılır.
 */
const QrEtiket = ({ qrMetni, baslik, qrKodu, boyut = 160, renk, isTipi }: Props) => {
    return (
        <div className={'d-inline-flex flex-column align-items-center rounded p-4 bg-white ' + (renk ? '' : 'border border-gray-300')} style={renk ? { border: '3px solid ' + renk } : undefined}>
            {
                baslik && (
                    <div className='fw-bold fs-5 text-gray-900 mb-3 text-center'>{baslik}</div>
                )
            }

            <QRCodeSVG value={qrMetni} size={boyut} level='M' includeMargin={false} />

            {
                isTipi && (
                    <div className='fw-bolder fs-3 mt-2' style={{ letterSpacing: 2, color: renk }}>{isTipi.toLocaleUpperCase('tr-TR')}</div>
                )
            }

            {
                qrKodu && (
                    <div className='fw-bolder fs-4 text-gray-800 mt-3' style={{ letterSpacing: 2 }}>{qrKodu}</div>
                )
            }
        </div>
    )
}

export default QrEtiket;
